import React from 'react';
import mountains from '../Assets/mountains.jpeg';
import styled from 'styled-components';
import data from '../Assets/data.json';
import 'bootstrap/dist/css/bootstrap.min.css';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-image: url("${mountains}");
  background-size: cover;
  width: 100vw;
  
  @media(min-width: 769px) {
    justify-content: space-around;
    padding: 0 21%;
    min-height: 100vh;
  }
  
  @media(max-width: 768px) {
    align-items: center;
    justify-content: space-evenly;
    min-height: 50vh;
  }
  
  @media(max-height: 900px) and (min-width: 1024px) {
    padding: 0 15%;
  }
`;

const Title = styled.h1`
  font-weight: bolder;
  
  @media(min-width: 769px) {
    font-size: 5rem;
  }
  
  @media(max-width: 768px) {
    font-size: 2rem;
  }
`;

const Quote = styled.span`
  @media(min-width: 769px) {
    font-size: 3rem;
  }
  
  @media(max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const Author = styled.span`
  @media(max-width: 768px) {
    font-size: 0.8rem;
  }
`;

const MainSection = () => {
    return (
        <Container>
            <Title>{data.main.title}</Title>
            <div>
                <Quote>{data.main.quote}</Quote>
                <br/>
                <Author>{data.main.author}</Author>
            </div>
        </Container>
    );
};

export default MainSection;
